import General from "../templates/General";
import Category from "../templates/Category";
import Description from "../templates/Description";

export default function GeneralTab(props) {
    const { labDetails, bindGeneralInfo } = props;
   
    return (
        <>
            <General labDetails={labDetails} bindGeneralInfo={bindGeneralInfo} />
            <Category labDetails={labDetails} bindGeneralInfo={bindGeneralInfo} />
            <Description labDetails={labDetails} bindGeneralInfo={bindGeneralInfo} />
           
        </>
    )
}